<ion-card (click)="selectNonUsfProduct()">
  <div class="label-container">
    <div class="product-name">
      {{ nonUsfProduct?.summary?.productDescTxtl }}
    </div>
    <div
      *ngIf="nonUsfProduct?.nonUSFData?.manufacturerProductNumber"
      class="sublabel"
    >
      {{ nonUsfProduct?.nonUSFData?.manufacturerProductNumber }}
    </div>
    <div *ngIf="nonUsfProduct?.nonUSFData?.vendorName" class="sublabel">
      {{ nonUsfProduct?.nonUSFData?.vendorName }}
    </div>
    <div *ngIf="nonUsfProduct?.summary?.salesPackSize" class="sublabel">
      {{ nonUsfProduct?.summary?.salesPackSize }}
    </div>
    <div *ngIf="nonUsfProduct?.pricing?.unitPrice" class="sublabel">
      {{ nonUsfProduct?.pricing?.unitPrice | currency }}
    </div>
  </div>
  <ion-checkbox
    value="{{ nonUsfProduct }}"
    [checked]="nonUsfProduct?.nonUSFData?.selected"
    mode="ios"
    justify="space-between"
    labelPlacement="start"
    class="checkbox"
    [attr.data-cy]="'radio-checkbox-' + index"
  >
  </ion-checkbox>
</ion-card>
